declare namespace $ {

	export class $bog_builderui_slider extends $rise_range {
	}
	
}

//# sourceMappingURL=slider.view.tree.d.ts.map